<template>
  <div
    class="new-project-container"
    :class="{
      'new-project-container-side-panel': this.$route.name !== 'newCompany',
    }"
  >
    <div class="new-project-header">
      <div class="left">
        <h2 class="title" v-if="this.$route.name === 'newCompany'">
          Създаване на нов отдел
        </h2>
        <template v-else-if="selectedProject !== undefined">
          <div
            class="left-project-name"
            :style="{
              backgroundColor: company.projects[selectedProject].color,
              color: getContrast(company.projects[selectedProject].color),
            }"
          >
            Преглед проект:&nbsp;
            <strong>{{ company.projects[selectedProject].projectName }}</strong>
          </div>
          <div
            class="project-settings"
            title="Тук са събрани настройките за активен/неактивен проект, цвят на проекта за Форма 76, и опцията проектът да е за Външни потребители"
            @click="openProjectSettings()"
          >
            <span class="mck2">Y</span>
            <p>НАСТРОЙКИ НА ПРОЕКТА</p>
          </div>
        </template>
        <div v-else></div>
      </div>
      <div class="buttons-wrapper">
        <!-- <div class="switch-wrapper" v-if="selectedProject !== undefined">
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="company.projects[selectedProject].isActive"
                @change="companyChanged()"
              />
              <span class="slider"></span>
            </label>
          </div>
          <label
            class="switch-label"
            v-if="!company.projects[selectedProject].isActive"
            @click="company.projects[selectedProject].isActive = false"
            >Неактивен обект</label
          >
          <label
            class="switch-label"
            v-else
            @click="company.projects[selectedProject].isActive = true"
            >Активен обект</label
          >
        </div>
        <div class="switch-wrapper" v-else>
          <div class="switch-container">
            <label class="switch">
              <input
                type="checkbox"
                v-model="newProject.isActive"
                @change="companyChanged()"
              />
              <span class="slider"></span>
            </label>
          </div>
          <label
            class="switch-label"
            v-if="!newProject.isActive"
            @click="newProject.isActive = false"
            >Неактивен обект</label
          >
          <label class="switch-label" v-else @click="newProject.isActive = true"
            >Активен обект</label
          >
        </div> -->
        <button class="btn btn-close desktop" @click="goBack">
          <span class="mck">F</span> Отказ
        </button>
        <button
          class="btn btn-new desktop"
          @click="save()"
          :disabled="isSaving"
        >
          <span class="mck">Y</span> Запис
        </button>
      </div>
    </div>
    <!-- NEW REPORT CONTENT -->
    <div
      class="new-wrapper"
      :class="{ 'new-wrapper-inactive': !isProjectActive() }"
    >
      <div
        class="new-content"
        :class="{ 'new-content-side-panel': this.$route.name !== 'newCompany' }"
      >
        <!-- ROW 1 -->
        <div class="new-content-inputs">
          <!-- ИМЕ НА ОТДЕЛ -->
          <div
            class="new-input-wrapper"
            v-if="this.$route.name === 'newCompany'"
          >
            <div class="new-input">
              <span class="mck icon--company">a</span>
              <input
                v-if="!company._id"
                type="text"
                placeholder="Име на отдел"
                @focus="getCompanies(), openDropdown(0)"
                @blur="closeDropdown(0)"
                v-model="searchCompanies"
                @change="companyChanged()"
                :disabled="
                  company.companyName.length ||
                  this.$route.name === 'newProject' ||
                  this.$route.name === 'getProject'
                "
              />
              <input
                v-else
                type="text"
                placeholder="Име на отдел"
                @focus="getCompanies(), openDropdown(0)"
                v-model="company.companyName"
                @blur="closeDropdown(0)"
                :disabled="
                  company.companyName.length ||
                  this.$route.name === 'newProject' ||
                  this.$route.name === 'getProject'
                "
              />
              <span
                v-if="
                  company.companyName.length &&
                  !(
                    this.$route.name === 'newProject' ||
                    this.$route.name === 'getProject'
                  )
                "
                class="clear"
                @click="resetSelectedCompany()"
                >F</span
              >
              <template
                v-if="
                  this.$route.name === 'newProject' ||
                  this.$route.name === 'getProject'
                "
              >
                <span
                  class="edit"
                  @click="toggleEdit(company.companyName, 'company')"
                  >c</span
                >
                <span class="disabled">A</span>
              </template>
            </div>
            <div
              class="new-input-dropdown"
              :class="{
                'new-input-dropdown-active':
                  openedDropdown[0] && this.$route.name !== 'newCompany',
              }"
            >
              <ul v-if="companies.length">
                <li
                  v-for="c in filteredCompanies()"
                  :key="c._id"
                  @click="selectCompany(c._id), companyChanged()"
                >
                  {{ c.companyName }}
                </li>
              </ul>
            </div>
          </div>
          <!-- ИМЕ НА ПРОЕКТ -->
          <div class="new-input-wrapper">
            <div class="new-input">
              <span class="mck icon--project">h</span>
              <input
                v-if="selectedProject === undefined"
                type="text"
                placeholder="Име на проект"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                v-model="searchProjects"
                @change="companyChanged()"
                :disabled="selectedProject !== undefined"
              />
              <input
                v-else
                type="text"
                placeholder="Име на проект"
                @focus="openDropdown(1)"
                @blur="closeDropdown(1)"
                v-model="company.projects[selectedProject].projectName"
                :disabled="selectedProject !== undefined"
              />
              <span
                v-if="selectedProject !== undefined"
                class="clear"
                @click="resetSelectedProject()"
                >F</span
              >
              <template v-if="this.$route.name === 'getProject'">
                <span
                  class="edit"
                  @click="
                    toggleEdit(
                      company.projects[selectedProject].projectName,
                      'project'
                    )
                  "
                  >c</span
                >
                <span class="disabled">A</span>
              </template>
            </div>
            <div
              class="new-input-dropdown"
              :class="{
                'new-input-dropdown-active':
                  openedDropdown[1] &&
                  this.$route.name !== 'newCompany' &&
                  this.$route.name !== 'newProject',
              }"
            >
              <ul v-if="company._id">
                <li
                  v-for="(p, index) in filteredProjects()"
                  :key="p._id"
                  @click="selectProject(index), companyChanged()"
                >
                  {{ p.projectName }}
                </li>
              </ul>
            </div>
          </div>
          <!-- Отчетници -->
          <div
            class="new-input-wrapper"
            v-if="this.$route.name !== 'newCompany'"
          >
            <div class="new-input new-input--hover" @click="toggleReporters()">
              <span class="mck icon--reporter">j</span>
              <input
                type="text"
                :placeholder="
                  !reportersList.length
                    ? 'Добави отчетници'
                    : `Отчетници: (${
                        reportersList.length
                      }) ${reportersList.join(', ')}`
                "
                :title="reportersList.length ? 'Редакция на отчетници' : null"
                :readonly="true"
              />
            </div>
          </div>
        </div>
        <!-- MOBILE REPORTERS / MATERIALS / ACTIVITIES / MECHANIZATIONS / MANHOURS -->
        <div
          class="new-content-data-row mobile"
          v-if="
            (selectedProject !== undefined || searchProjects.length) &&
            this.$route.name !== 'newCompany'
          "
        >
          <!-- MECHANIZATIONS -->
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle mobile"
              @click="isAddMechanizationsModalOpened = true"
            >
              <p>Добави собствени механизации</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="mck2">3</span>
              </span>
            </div>
          </div>
          <!-- MATERIALS -->
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle mobile"
              @click="isAddMaterialsModalOpened = true"
            >
              <p>Добави материали</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="mck">T</span>
              </span>
            </div>
          </div>
          <!-- ACTIVITIES -->
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle mobile"
              @click="isAddActivitiesModalOpened = true"
            >
              <p>Добави дейности</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="mck">U</span>
              </span>
            </div>
          </div>
          <!-- REPORTERS -->
          <div class="new-content-data-item">
            <div
              class="new-content-data-item-toggle mobile"
              @click="isAddUsersModalOpened = true"
            >
              <p>Добави отчетници</p>
              <span class="new-content-data-item-toggle-circle">
                <span class="mck">V</span>
              </span>
            </div>
          </div>
        </div>

        <!-- REPORTERS / MATERIALS / ACTIVITIES / MECHANIZATIONS / MANHOURS -->
        <div
          class="new-content-data-row"
          v-if="viewLists() && this.$route.name !== 'newCompany'"
          :class="{ 'new-content-data-row-active': viewLists() }"
        >
          <!-- MECHANIZATIONS -->
          <div
            class="new-content-data-item"
            :class="{
              'new-content-data-item--hoverable':
                (selectedProject !== undefined &&
                  company.projects[selectedProject].mechanizations.length) ||
                newProject.mechanizations.length,
            }"
            :title="
              (selectedProject !== undefined &&
                company.projects[selectedProject].mechanizations.length) ||
              newProject.mechanizations.length
                ? 'Редакция на собствени механизации'
                : ''
            "
            @click="openModal('isAddMechanizationsModalOpened')"
          >
            <div class="new-content-data-item-toggle">
              <p>
                <strong>СОБСТВЕНИ МЕХАНИЗАЦИИ</strong>
              </p>
              <span class="mck">n</span>
            </div>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <template v-if="selectedProject !== undefined">
                  <table>
                    <tr
                      v-for="(mechanization, index) in company.projects[
                        selectedProject
                      ].mechanizations"
                      :key="`addedMechanization-${index}-${mechanization.name}`"
                    >
                      <td
                        class="ma-cell ma-cell-name"
                        :class="{
                          'ma-cell-additional': mechanization.isAdditional,
                        }"
                      >
                        {{ mechanization.name }}
                        <span class="mck" v-if="mechanization.isAdditional"
                          >O</span
                        >
                      </td>
                      <td class="ma-cell">{{ mechanization.unit }}</td>
                      <!-- <td class="ma-cell">{{(+mechanization.price).toFixed(2)}} €</td> -->
                    </tr>
                  </table>

                  <img
                    @click.stop="
                      openModal('isAddMechanizationsModalOpened', true)
                    "
                    class="new-img"
                    v-if="
                      !company.projects[selectedProject].mechanizations.length
                    "
                    src="../assets/img/newMech.svg"
                    alt="Импортирай собствени механизации"
                  />
                </template>
                <template v-else>
                  <table>
                    <tr
                      v-for="(
                        mechanization, index
                      ) in newProject.mechanizations"
                      :key="`addedMechanization-${index}-${mechanization.name}`"
                    >
                      <td class="ma-cell ma-cell-name">
                        {{ mechanization.name }}
                      </td>
                      <td class="ma-cell">{{ mechanization.unit }}</td>
                      <!-- <td class="ma-cell">{{(+mechanization.price).toFixed(2)}} €</td> -->
                    </tr>
                  </table>

                  <img
                    @click.stop="
                      openModal('isAddMechanizationsModalOpened', true)
                    "
                    class="new-img"
                    v-if="!newProject.mechanizations.length"
                    src="../assets/img/newMech.svg"
                    alt="Импортирай собствени механизации"
                  />
                </template>
              </div>
            </div>
          </div>
          <!-- RENTED MECHANIZATIONS -->
          <div
            class="new-content-data-item"
            :class="{
              'new-content-data-item--hoverable':
                (selectedProject !== undefined &&
                  company.projects[selectedProject].mechanizations.length) ||
                newProject.mechanizations.length,
            }"
            :title="
              (selectedProject !== undefined &&
                company.projects[selectedProject].mechanizations.length) ||
              newProject.mechanizations.length
                ? 'Редакция на собствени механизации'
                : ''
            "
            @click="openModal('isAddRentedMechanizationsModalOpened')"
          >
            <div class="new-content-data-item-toggle">
              <p>
                <strong>НАЕТИ МЕХАНИЗАЦИИ</strong>
              </p>
              <span class="mck">m</span>
            </div>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <template v-if="selectedProject !== undefined">
                  <table>
                    <tr
                      v-for="(mechanization, index) in company.projects[
                        selectedProject
                      ].rentedMechanizations"
                      :key="`addedMechanization-${index}-${mechanization.name}`"
                    >
                      <td
                        class="ma-cell ma-cell-name"
                        :class="{
                          'ma-cell-additional': mechanization.isAdditional,
                        }"
                      >
                        {{ mechanization.name }}
                        <span class="mck" v-if="mechanization.isAdditional"
                          >O</span
                        >
                      </td>
                      <td class="ma-cell">{{ mechanization.unit }}</td>
                      <!-- <td class="ma-cell">{{(+mechanization.price).toFixed(2)}} €</td> -->
                    </tr>
                  </table>

                  <img
                    @click.stop="
                      openModal('isAddRentedMechanizationsModalOpened', true)
                    "
                    class="new-img"
                    v-if="
                      !company.projects[selectedProject].rentedMechanizations
                        .length
                    "
                    src="../assets/img/newRentMech.svg"
                    alt="Импортирай наети механизации"
                  />
                </template>
                <template v-else>
                  <table>
                    <tr
                      v-for="(
                        mechanization, index
                      ) in newProject.rentedMechanizations"
                      :key="`addedMechanization-${index}-${mechanization.name}`"
                    >
                      <td class="ma-cell ma-cell-name">
                        {{ mechanization.name }}
                      </td>
                      <td class="ma-cell">{{ mechanization.unit }}</td>
                      <!-- <td class="ma-cell">{{(+mechanization.price).toFixed(2)}} €</td> -->
                    </tr>
                  </table>

                  <img
                    @click.stop="
                      openModal('isAddRentedMechanizationsModalOpened', true)
                    "
                    class="new-img"
                    v-if="!newProject.rentedMechanizations.length"
                    src="../assets/img/newRentMech.svg"
                    alt="Импортирай наети механизации"
                  />
                </template>
              </div>
            </div>
          </div>
          <!-- MATERIALS -->
          <div
            class="new-content-data-item"
            :class="{
              'new-content-data-item--hoverable':
                (selectedProject !== undefined &&
                  company.projects[selectedProject].materials.length) ||
                newProject.materials.length,
            }"
            :title="
              (selectedProject !== undefined &&
                company.projects[selectedProject].materials.length) ||
              newProject.materials.length
                ? 'Редакция на материали'
                : ''
            "
            @click="openModal('isAddMaterialsModalOpened')"
          >
            <div class="new-content-data-item-toggle">
              <p>
                <strong>МАТЕРИАЛИ</strong>
              </p>
              <span class="mck">T</span>
            </div>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <template v-if="selectedProject !== undefined">
                  <table>
                    <tr
                      v-for="(material, index) in company.projects[
                        selectedProject
                      ].materials"
                      :key="`addedMaterial-${index}-${material.name}`"
                    >
                      <td
                        class="ma-cell ma-cell-name"
                        :class="{ 'ma-cell-additional': material.isAdditional }"
                      >
                        <span class="mck" v-if="material.isAdditional">G</span>
                        {{ material.name }}
                      </td>
                      <td class="ma-cell">{{ material.unit }}</td>
                      <!-- <td class="ma-cell">{{(+material.price).toFixed(2)}} €</td> -->
                    </tr>
                  </table>

                  <img
                    @click.stop="openModal('isAddMaterialsModalOpened', true)"
                    class="new-img"
                    v-if="!company.projects[selectedProject].materials.length"
                    src="../assets/img/newMate.svg"
                    alt="Импортирай материали"
                  />
                </template>
                <template v-else>
                  <table>
                    <tr
                      v-for="(material, index) in newProject.materials"
                      :key="`addedMaterial-${index}-${material.name}`"
                    >
                      <td class="ma-cell ma-cell-name">{{ material.name }}</td>
                      <td class="ma-cell">{{ material.unit }}</td>
                      <!-- <td class="ma-cell">{{(+material.price).toFixed(2)}} €</td> -->
                    </tr>
                  </table>

                  <img
                    @click.stop="openModal('isAddMaterialsModalOpened', true)"
                    class="new-img"
                    v-if="!newProject.materials.length"
                    src="../assets/img/newMate.svg"
                    alt="Импортирай материали"
                  />
                </template>
              </div>
            </div>
          </div>
          <!-- MAN HOURS -->
          <div
            class="new-content-data-item"
            :class="{
              'new-content-data-item--hoverable':
                (selectedProject !== undefined &&
                  company.projects[selectedProject].manHours.length) ||
                newProject.manHours.length,
            }"
            :title="
              (selectedProject !== undefined &&
                company.projects[selectedProject].manHours.length) ||
              newProject.manHours.length
                ? 'Редакция на дейности'
                : ''
            "
            @click="openModal('isAddManHoursModalOpened')"
          >
            <div class="new-content-data-item-toggle">
              <p>
                <strong>ЧОВЕКОЧАСОВЕ</strong>
              </p>
              <span class="mck">k</span>
            </div>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <template v-if="selectedProject !== undefined">
                  <table>
                    <tr
                      v-for="(mh, index) in company.projects[selectedProject]
                        .manHours"
                      :key="`addedManHour-${index}-${mh.position.name}`"
                    >
                      <td class="ma-cell ma-cell-name ma-cell-left">
                        {{ mh.position.name }} ({{ mh.part }})
                      </td>
                      <td class="ma-cell nowrap">{{ mh.quantity }} чч.</td>
                    </tr>
                  </table>

                  <img
                    @click.stop="openModal('isAddManHoursModalOpened', true)"
                    class="new-img"
                    v-if="!company.projects[selectedProject].manHours.length"
                    src="../assets/img/newMh.svg"
                    alt="Импортирай човекочасове"
                  />
                </template>
                <template v-else>
                  <table>
                    <tr
                      v-for="(mh, index) in newProject.manHours"
                      :key="`addedManHour-${index}-${mh.position.name}`"
                    >
                      <td class="ma-cell ma-cell-name ma-cell-left">
                        {{ mh.position.name }} ({{ mh.part }})
                      </td>
                      <td class="ma-cell nowrap">{{ mh.quantity }} чч.</td>
                    </tr>
                  </table>

                  <img
                    @click.stop="openModal('isAddManHoursModalOpened', true)"
                    class="new-img"
                    v-if="!newProject.manHours.length"
                    src="../assets/img/newMh.svg"
                    alt="Импортирай човекочасове"
                  />
                </template>
              </div>
            </div>
          </div>
          <!-- ACTIVITIES -->
          <div
            class="new-content-data-item"
            :class="{
              'new-content-data-item--hoverable':
                (selectedProject !== undefined &&
                  company.projects[selectedProject].activities.length) ||
                newProject.activities.length,
            }"
            :title="
              (selectedProject !== undefined &&
                company.projects[selectedProject].activities.length) ||
              newProject.activities.length
                ? 'Редакция на дейности'
                : ''
            "
            @click="openModal('isAddActivitiesModalOpened')"
          >
            <div class="new-content-data-item-toggle">
              <p>
                <strong>ДЕЙНОСТИ</strong>
              </p>
              <span class="mck">U</span>
            </div>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <template v-if="selectedProject !== undefined">
                  <table>
                    <tr
                      v-for="(activity, index) in company.projects[
                        selectedProject
                      ].activities"
                      :key="`addedActivity-${index}-${activity.name}`"
                    >
                      <td
                        class="ma-cell ma-cell-name"
                        :class="{ 'ma-cell-additional': activity.isAdditional }"
                      >
                        {{ activity.name }}
                        <span class="mck" v-if="activity.isAdditional">O</span>
                      </td>
                      <td class="ma-cell">{{ activity.unit }}</td>
                      <!-- <td class="ma-cell">{{(+activity.price).toFixed(2)}} €</td> -->
                    </tr>
                  </table>

                  <img
                    @click.stop="openModal('isAddActivitiesModalOpened', true)"
                    class="new-img"
                    v-if="!company.projects[selectedProject].activities.length"
                    src="../assets/img/newAct.svg"
                    alt="Импортирай дейности"
                  />
                </template>
                <template v-else>
                  <table>
                    <tr
                      v-for="(activity, index) in newProject.activities"
                      :key="`addedActivity-${index}-${activity.name}`"
                    >
                      <td class="ma-cell ma-cell-name">{{ activity.name }}</td>
                      <td class="ma-cell">{{ activity.unit }}</td>
                      <!-- <td class="ma-cell">{{(+activity.price).toFixed(2)}} €</td> -->
                    </tr>
                  </table>

                  <img
                    @click.stop="openModal('isAddActivitiesModalOpened', true)"
                    class="new-img"
                    v-if="!newProject.activities.length"
                    src="../assets/img/newAct.svg"
                    alt="Импортирай дейности"
                  />
                </template>
              </div>
            </div>
          </div>
          <!-- PARTS -->
          <div
            class="new-content-data-item"
            :class="{ 'new-content-data-item--hoverable': getParts.length }"
            :title="getParts.length ? 'Редакция на части' : ''"
            @click="openParts()"
          >
            <div class="new-content-data-item-toggle">
              <p>
                <strong>ЧАСТИ/БЮДЖЕТИ</strong>
              </p>
              <span class="mck">i</span>
            </div>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <table>
                  <tr v-for="(p, i) in getPartsManual" :key="`part-m-${i}`">
                    <td class="ma-cell ma-cell-name ma-cell-additional">
                      {{ p }}
                      <span class="mck">i</span>
                    </td>
                  </tr>
                  <tr v-for="(p, i) in getParts" :key="`part-${i}`">
                    <td class="ma-cell ma-cell-name">{{ p }}</td>
                  </tr>
                </table>

                <img
                  class="new-img"
                  v-if="!getParts.length && !getPartsManual.length"
                  src="../assets/img/newParts2.svg"
                  alt="Части"
                />
              </div>
            </div>
          </div>
          <!-- INVENTORY -->
          <div
            class="new-content-data-item"
            :class="{ 'new-content-data-item--hoverable': inventories.length }"
            title="Добавяне на инвентар към проекта"
            @click="openInventories()"
          >
            <div class="new-content-data-item-toggle">
              <p>
                <strong>ИНВЕНТАР</strong>
              </p>
              <span class="mck">U</span>
            </div>
            <div v-if="viewLists()" class="new-content-data-item-content">
              <div class="new-content-data-item-content-lists">
                <table>
                  <tr v-for="(inv, i) in inventories" :key="`inv-${i}`">
                    <td class="ma-cell ma-cell-name no-padding">
                      {{ getInventoryName(inv) }}
                    </td>
                  </tr>
                </table>

                <img
                  class="new-img"
                  v-if="!inventories.length"
                  src="../assets/img/newInv.svg"
                  alt="Части"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- BUTONS MOBILE -->
        <div class="btns mobile">
          <button class="btn btn-close" @click="goBack">
            <span class="mck">F</span> Отказ
          </button>
          <button class="btn btn-new" @click="save()" :disabled="isSaving">
            <span class="mck">Y</span> Запис
          </button>
        </div>
        <!-- BUTTON DELETE -->
        <!-- <div class="delete-wrapper">
          <button class="btn btn-delete" v-if="company._id" @click="deleteCompany()">
            <span class="mck">b</span>Изтриване на отдел
          </button>
        </div>-->
      </div>
    </div>
    <!-- ADD REPORTERS MODAL -->
    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :incomingUsers="getReportersForModal()"
        :usersType="'reporters'"
      />
    </transition>
    <!-- ADD MATERIALS MODAL -->
    <transition name="fade">
      <AddMaterialsModal
        v-if="isAddMaterialsModalOpened"
        :incomingMaterials="getMaterialsForModal()"
        :toggleImport="toggleImport"
      />
    </transition>
    <!-- ADD ACTIVITIES MODAL -->
    <transition name="fade">
      <AddActivitiesModal
        v-if="isAddActivitiesModalOpened"
        :incomingActivities="getActivitiesForModal()"
        :toggleImport="toggleImport"
      />
    </transition>
    <!-- ADD PARTS MODAL -->
    <transition name="fade">
      <AddPartsModal
        v-if="isAddPartsModalOpened"
        :incomingMaterials="getMaterialsForModal()"
        :incomingActivities="getActivitiesForModal()"
        :incomingMechanizations="getMechanizationsForModal()"
        :incomingRentedMechanizations="getRentedMechanizationsForModal()"
        :incomingManHours="getManHoursForModal()"
        :incomingPartNotifications="getPartNotificationsForModal()"
        :incomingParts="getPartsForModal()"
        :parts="getParts"
        @close="closeAddPartsModal"
        @save="saveUpdatedParts"
      />
    </transition>
    <!-- ADD INVENTORY MODAL -->
    <transition name="fade">
      <AddInventoriesModal
        v-if="isAddInventoriesModalOpened"
        :ids="isAddInventoriesModalOpened"
        @close="(isAddInventoriesModalOpened = false), getInventories()"
      />
    </transition>
    <!-- ADD MECHANIZATIONS MODAL -->
    <transition name="fade">
      <AddMechanizationsModal
        v-if="isAddMechanizationsModalOpened"
        :incomingMechanizations="getMechanizationsForModal()"
        :toggleImport="toggleImport"
      />
    </transition>
    <!-- ADD RENTED MECHANIZATIONS MODAL -->
    <transition name="fade">
      <AddMechanizationsModal
        v-if="isAddRentedMechanizationsModalOpened"
        :incomingMechanizations="getRentedMechanizationsForModal()"
        rented="true"
        :toggleImport="toggleImport"
      />
    </transition>
    <!-- ADD MANHOURS MODAL -->
    <transition name="fade">
      <AddManHoursModal
        v-if="isAddManHoursModalOpened"
        :incomingManHours="getManHoursForModal()"
        :toggleImport="toggleImport"
        :parts="getParts"
        @save="handleManHours"
        @close="closeAddManHoursModal"
      />
    </transition>
    <!-- ADD ACTIVITIES MODAL -->
    <transition name="fade">
      <EditInputModal
        v-if="isEditInputModalOpened"
        :inputForEdit="inputForEdit"
        :isComingFromCompany="true"
      />
    </transition>
    <transition name="fade">
      <UnsavedChangesModal v-if="isUnsavedChangesModalOpened" />
    </transition>
    <transition name="fade">
      <ProjectSettingsModal
        v-if="isProjectSettingsModalOpen"
        @close="
          (isProjectSettingsModalOpen = false),
            $event ? (isCompanyChanged = $event) : null
        "
        :project="company.projects[selectedProject]"
      />
    </transition>
  </div>
</template>

<script>
import AddUsersModal from "./shared/AddUsersModal";
import AddMaterialsModal from "./shared/AddMaterialsModal";
import AddActivitiesModal from "./shared/AddActivitiesModal";
import AddPartsModal from "./shared/AddPartsModal";
import AddInventoriesModal from "./shared/AddInventoriesModal";
import AddMechanizationsModal from "./shared/AddMechanizationsModal";
import AddManHoursModal from "./shared/AddManHoursModal";
import EditInputModal from "./shared/EditInputModal";
import UnsavedChangesModal from "./shared/UnsavedChangesModal";
import ProjectSettingsModal from "./shared/ProjectSettingsModal";
import log from "./mixins/log.js";
import contrast from "./mixins/contrast.js";
import { getAccess } from "./mixins/getAccess";
export default {
  components: {
    AddUsersModal,
    AddMaterialsModal,
    AddActivitiesModal,
    AddPartsModal,
    AddMechanizationsModal,
    AddManHoursModal,
    UnsavedChangesModal,
    EditInputModal,
    ProjectSettingsModal,
    AddInventoriesModal,
  },
  mixins: [log, contrast],
  props: ["idToEdit"],
  watch: {
    "$route.path"() {
      this.setRoutes();
    },
  },
  computed: {
    reportersList() {
      let list = [];

      if (this.selectedProject !== undefined) {
        this.company.projects[this.selectedProject].reporters.forEach((r) => {
          list.push(r.name);
        });
      } else {
        this.newProject.reporters.forEach((r) => {
          list.push(r.name);
        });
      }

      return list;
    },
    getParts() {
      const parts = [];

      if (this.selectedProject !== undefined) {
        for (let m of this.company.projects[this.selectedProject].manHours) {
          if (m.part && parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
        for (let m of this.company.projects[this.selectedProject]
          .mechanizations) {
          if (m.part && parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
        for (let m of this.company.projects[this.selectedProject]
          .rentedMechanizations) {
          if (m.part && parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
        for (let m of this.company.projects[this.selectedProject].materials) {
          if (m.part && parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
        for (let a of this.company.projects[this.selectedProject].activities) {
          if (a.part && parts.indexOf(a.part) === -1) {
            parts.push(a.part);
          }
        }
        // for (let p of this.company.projects[this.selectedProject].parts) {
        //   if (p.name && parts.indexOf(p.name) === -1) {
        //     parts.push(p.name);
        //   }
        // }
      } else {
        for (let m of this.newProject.mechanizations) {
          if (m.part && parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
        for (let m of this.newProject.rentedMechanizations) {
          if (m.part && parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
        for (let m of this.newProject.materials) {
          if (m.part && parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
        for (let a of this.newProject.activities) {
          if (a.part && parts.indexOf(a.part) === -1) {
            parts.push(a.part);
          }
        }
        for (let m of this.newProject.manHours) {
          if (m.part && parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
        // for (let p of this.newProject.parts) {
        //   if (p.name && parts.indexOf(p.name) === -1) {
        //     parts.push(p.name);
        //   }
        // }
      }
      return parts.sort();
    },
    getPartsManual() {
      const parts = [];

      if (this.selectedProject !== undefined) {
        for (let p of this.company.projects[this.selectedProject].parts) {
          if (p.name && parts.indexOf(p.name) === -1) {
            parts.push(p.name);
          }
        }
      } else {
        for (let p of this.newProject.parts) {
          if (p.name && parts.indexOf(p.name) === -1) {
            parts.push(p.name);
          }
        }
      }
      return parts.sort();
    },
  },
  data() {
    return {
      isCompanyChanged: false,
      isSaving: false,
      incomingActivities: [],
      incomingMaterials: [],
      incomingMechanizations: [],
      incomingRentedMechanizations: [],
      incomingManHours: [],
      // А boolean for every dropdown in the template
      openedDropdown: [false, false, false, false],
      // Booleans for reporters/materials/activies/ selections modals
      isAddUsersModalOpened: false,
      isAddMaterialsModalOpened: false,
      isAddActivitiesModalOpened: false,
      isAddPartsModalOpened: false,
      isAddInventoriesModalOpened: false,
      isAddMechanizationsModalOpened: false,
      isAddRentedMechanizationsModalOpened: false,
      isAddManHoursModalOpened: false,
      isEditInputModalOpened: false,
      isUnsavedChangesModalOpened: false,
      isProjectSettingsModalOpen: false,
      inputForEdit: {
        value: "",
        where: "",
      },
      toggleImport: false,
      isActive: true,
      selectedProject: undefined,
      selectedPart: undefined,
      // SEARCH
      searchCompanies: "",
      searchProjects: "",
      searchParts: "",
      // The main company object
      companies: [],
      users: [],
      inventories: [],
      // The specific company object
      company: {
        _id: undefined,
        companyName: "",
        projects: [
          {
            projectName: "",
            isActive: true,
            materials: [],
            activities: [],
            mechanizations: [],
            rentedMechanizations: [],
            manHours: [],
            partNotifications: [],
            reporters: [],
            parts: [],
          },
        ],
      },
      newProject: {
        projectName: "",
        isActive: true,
        materials: [],
        activities: [],
        mechanizations: [],
        rentedMechanizations: [],
        manHours: [],
        partNotifications: [],
        reporters: [],
        parts: [],
      },
      newPart: {
        partName: "",
      },
    };
  },
  methods: {
    openProjectSettings() {
      if (getAccess("companies_projects", "companies", true)) {
        this.isProjectSettingsModalOpen = true;
      }
    },
    // DROPDOWNS
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    openParts() {
      if (getAccess("companies_projects", "companies", true)) {
        if (this.getParts.length) {
          this.isAddPartsModalOpened = true;
        } else {
          this.$snotify.warning("Първо трябва да добавите дейности");
        }
      }
    },
    openInventories() {
      if (getAccess("companies_projects", "companies", true)) {
        this.isAddInventoriesModalOpened = {
          company: this.company._id,
          project: this.company.projects[this.selectedProject]._id,
        };
      }
    },
    openModal(modalName, toggleImport) {
      if (getAccess("companies_projects", "companies", true)) {
        this[modalName] = true;
        if (toggleImport) this.toggleImport = true;
      }
    },
    getInventoryName(i) {
      return [i.name, i.brand, i.serialNumber].filter((x) => x).join(" - ");
    },
    isProjectActive() {
      if (this.selectedProject !== undefined) {
        return this.company.projects[this.selectedProject].isActive;
      }
      return this.newProject.isActive;
    },
    // SELECTING
    // 1 - SELECT COMPANY BY ID
    selectCompany(id) {
      this.selectedProject = undefined;
      this.selectedPart = undefined;
      this.getCompany(id);
    },
    // 2 - SELECT THE INDEX OF A 'PROJECT' INSIDE COMPANY
    selectProject(project) {
      this.selectedPart = undefined;
      this.selectedProject = project;
    },
    // 4 - SELECT THE INDEX OF A 'PART' INSIDE AN OBJECT
    selectPart(part) {
      this.selectedPart = part;
    },
    // RESET SELECTED AND EVERYTHING NESTED INSIDE ON FOCUS
    resetSelectedCompany() {
      this.company = {
        companyName: "",
        projects: [
          {
            _id: "",
            isActive: true,
            projectName: "",
            materials: [],
            activities: [],
            mechanizations: [],
            rentedMechanizations: [],
            manHours: [],
            partNotifications: [],
            reporters: [],
            parts: [],
          },
        ],
      };
      this.newProject = {
        projectName: "",
        isActive: true,
        materials: [],
        activities: [],
        mechanizations: [],
        rentedMechanizations: [],
        manHours: [],
        partNotifications: [],
        reporters: [],
        parts: [],
      };
      this.newPart = {
        partName: "",
      };
      this.searchCompanies = "";
      this.resetSelectedProject();
    },
    resetSelectedProject() {
      this.selectedProject = undefined;
      this.searchProjects = "";
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      return this.companies.filter((c) => {
        return c.companyName
          .toLowerCase()
          .includes(this.searchCompanies.toLowerCase());
      });
    },
    filteredProjects() {
      return this.company.projects.filter((p) => {
        return p.projectName
          .toLowerCase()
          .includes(this.searchProjects.toLowerCase());
      });
    },
    // RETURN IF REPORTERS/MATERIALS/ACTIVITIES/MECHANIZATIONS/MANHOURS SECTION SHOULD BE VISIBLE
    viewLists() {
      if (this.selectedProject !== undefined) {
        return true;
      } else {
        return this.searchProjects.length;
      }
    },
    toggleReporters() {
      if (
        getAccess("companies_projects", "companies", true) &&
        this.viewLists()
      ) {
        this.isAddUsersModalOpened = true;
      }
    },
    getReportersForModal() {
      if (this.selectedProject === undefined) {
        return this.newProject.reporters;
      } else {
        return this.company.projects[this.selectedProject].reporters;
      }
    },
    getMaterialsForModal() {
      if (this.selectedProject === undefined) {
        return this.newProject.materials;
      } else {
        return this.company.projects[this.selectedProject].materials;
      }
    },
    getActivitiesForModal() {
      if (this.selectedProject === undefined) {
        return this.newProject.activities;
      } else {
        return this.company.projects[this.selectedProject].activities;
      }
    },
    getMechanizationsForModal() {
      if (this.selectedProject === undefined) {
        return this.newProject.mechanizations;
      } else {
        return this.company.projects[this.selectedProject].mechanizations;
      }
    },
    getRentedMechanizationsForModal() {
      if (this.selectedProject === undefined) {
        return this.newProject.rentedMechanizations;
      } else {
        return this.company.projects[this.selectedProject].rentedMechanizations;
      }
    },
    getManHoursForModal() {
      if (this.selectedProject === undefined) {
        return this.newProject.manHours;
      } else {
        return this.company.projects[this.selectedProject].manHours;
      }
    },
    getPartNotificationsForModal() {
      if (this.selectedProject === undefined) {
        return this.newProject.partNotifications;
      } else {
        return this.company.projects[this.selectedProject].partNotifications;
      }
    },
    getPartsForModal() {
      if (this.selectedProject === undefined) {
        return this.newProject.parts;
      } else {
        return this.company.projects[this.selectedProject].parts;
      }
    },
    // HANDLE THE REPORTERS/MATERIALS/ACTIVITIES/MECHANIZATIONS RETURNED FROM THE MODALS
    // If we get the 'saveAddUsersModal' event, we assign the workers we receive to the selected/new project
    handleReporters(reporters) {
      if (this.selectedProject === undefined) {
        this.newProject.reporters = reporters;
      } else {
        this.company.projects[this.selectedProject].reporters = reporters;
      }
      this.closeAddUsersModal();
      this.companyChanged();
    },
    // If we get the 'saveAddMaterialsModal' event, we assign the items we receive to the selected/new project
    handleMaterials(materials) {
      if (this.selectedProject === undefined) {
        this.newProject.materials = materials;
      } else {
        this.company.projects[this.selectedProject].materials = materials;
      }
      this.closeAddMaterialsModal();
      this.companyChanged();
    },
    // If we get the 'saveAddActivitiesModal' event, we assign the items we receive to the selected/new project
    handleActivities(activities) {
      if (this.selectedProject === undefined) {
        this.newProject.activities = activities;
      } else {
        this.company.projects[this.selectedProject].activities = activities;
      }
      this.closeAddActivitiesModal();
      this.companyChanged();
    },
    // If we get the 'saveAddMechanizationsModal' event, we assign the items we receive to the selected/new project
    handleMechanizations(mechanizations) {
      if (this.selectedProject === undefined) {
        this.newProject.mechanizations = mechanizations;
      } else {
        this.company.projects[this.selectedProject].mechanizations =
          mechanizations;
      }
      this.closeAddMechanizationsModal();
      this.companyChanged();
    },
    handleRentedMechanizations(rentedMechanizations) {
      if (this.selectedProject === undefined) {
        this.newProject.rentedMechanizations = rentedMechanizations;
      } else {
        this.company.projects[this.selectedProject].rentedMechanizations =
          rentedMechanizations;
      }
      this.closeAddRentedMechanizationsModal();
      this.companyChanged();
    },
    handleManHours(mh) {
      if (this.selectedProject === undefined) {
        this.newProject.manHours = mh;
      } else {
        this.company.projects[this.selectedProject].manHours = mh;
      }
      this.closeAddManHoursModal();
      this.companyChanged();
    },
    // If we get the 'saveEditInputModal' event, we change the name of the field we need to change
    handleEdit(edited) {
      if (edited.where === "company") {
        this.company.companyName = edited.value;
        this.$snotify.warning(
          "Успешно редактирахте компания. За да запазите промяната кликнете бутон 'Запис'!"
        );
      } else if (edited.where === "project") {
        this.company.projects[this.selectedProject].projectName = edited.value;
        this.$snotify.warning(
          "Успешно редактирахте проект. За да запазите промяната кликнете бутон 'Запис'!"
        );
      }
      this.closeEditInputModal();
      this.companyChanged();
    },
    saveUpdatedParts(e) {
      if (this.selectedProject === undefined) {
        this.newProject.mechanizations = e.mechanizations;
        this.newProject.rentedMechanizations = e.rentedMechanizations;
        this.newProject.materials = e.materials;
        this.newProject.activities = e.activities;
        this.newProject.manHours = e.manHours;
        this.newProject.partNotifications = e.partNotifications;
        this.newProject.parts = e.parts;
      } else {
        this.company.projects[this.selectedProject].mechanizations =
          e.mechanizations;
        this.company.projects[this.selectedProject].rentedMechanizations =
          e.rentedMechanizations;
        this.company.projects[this.selectedProject].materials = e.materials;
        this.company.projects[this.selectedProject].activities = e.activities;
        this.company.projects[this.selectedProject].manHours = e.manHours;
        this.company.projects[this.selectedProject].partNotifications =
          e.partNotifications;
        this.company.projects[this.selectedProject].parts = e.parts;
      }

      this.closeAddPartsModal();
    },
    // Close the modals when we got the corresponding event
    closeAddUsersModal() {
      this.isAddUsersModalOpened = false;
    },
    closeAddMaterialsModal() {
      this.isAddMaterialsModalOpened = false;
      this.toggleImport = false;
    },
    closeAddActivitiesModal() {
      this.isAddActivitiesModalOpened = false;
      this.toggleImport = false;
    },
    closeAddPartsModal() {
      this.isAddPartsModalOpened = false;
    },
    closeAddMechanizationsModal() {
      this.isAddMechanizationsModalOpened = false;
      this.toggleImport = false;
    },
    closeAddRentedMechanizationsModal() {
      this.isAddRentedMechanizationsModalOpened = false;
      this.toggleImport = false;
    },
    closeAddManHoursModal() {
      this.isAddManHoursModalOpened = false;
      this.toggleImport = false;
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
    toggleEdit(value, where) {
      if (getAccess("companies_projects", "companies", true)) {
        this.inputForEdit = {
          value: value,
          where: where,
        };
        this.isEditInputModalOpened = true;
      }
    },
    // REQUESTS
    // GET ALL COMPANIES REQUEST
    getCompanies() {
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/names`;
      this.$http
        .get(requestUrl)
        .then((response) => {
          this.companies = response.data;
          // console.log(JSON.stringify(this.companies));
        })
        .catch((error) => console.log(error));
    },
    // GET SPECIFIC COMPANY BY ID REQUEST
    getCompany(companyId) {
      this.resetSelectedProject();
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;
        })
        .catch((error) => console.log(error));
    },
    // GET and SET Selected Company and Project
    getProject(companyId, projectId) {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${companyId}`;
      this.$http
        .get(url)
        .then((response) => {
          this.company = response.data;

          for (let project in this.company.projects) {
            if (this.company.projects[project]._id == projectId) {
              // SET Project
              this.selectedProject = project;
            }
          }

          if (this.$route.query.openModal) {
            if (this.$route.query.openModal === "materials") {
              this.openModal("isAddMaterialsModalOpened");
            } else if (this.$route.query.openModal === "activities") {
              this.openModal("isAddActivitiesModalOpened");
            } else if (this.$route.query.openModal === "mechanizations") {
              this.openModal("isAddMechanizationsModalOpened");
            } else if (this.$route.query.openModal === "rentedMechanizations") {
              this.openModal("isAddRentedMechanizationsModalOpened");
            } else if (this.$route.query.openModal === "manHours") {
              this.openModal("isAddManHoursModalOpened");
            }
          }

          this.getInventories();
        })
        .catch((error) => console.log(error));
    },
    getInventories() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(
          `${process.env.VUE_APP_BASE_URI}/inventory/${this.company._id}/${
            this.company.projects[this.selectedProject]._id
          }`
        )
        .then((response) => {
          this.inventories = response.data;

          this.$store.dispatch("stopLoading");
        });
    },
    companyChanged() {
      if (!this.isCompanyChanged) {
        this.isCompanyChanged = true;
      }
    },
    save() {
      if (this.isSaving) return;

      // IF THERE IS NO SELECTED COMPANY WE'RE MAKING A BRAND NEW ONE
      if (!this.company._id) {
        if (!this.fieldsValidation()) return;

        if (!confirm("Сигурни ли сте, че искате да създадете нов отдел?")) {
          return;
        }

        this.isSaving = true;
        this.postCompany();
        // IN ALL OTHER CASES WE'RE UPDATING AN EXISTING ONE
      } else if (this.company._id) {
        this.isSaving = true;
        this.updateCompany();
      }
    },
    checkForUnsavedData(next) {
      this.isUnsavedChangesModalOpened = true;
      this.$once("closeUnsavedChangesModal", (answer) => {
        // confirm
        if (answer) {
          next(false);
          this.save();
        }
        // decline
        else {
          next();
        }
        this.isUnsavedChangesModalOpened = false;
        this.isCompanyChanged = false;
      });
    },
    // POST COMPANY REQUEST
    postCompany() {
      this.company.companyName = this.searchCompanies;
      this.company.projects[0].projectName = this.searchProjects;
      this.company.projects[0].materials = this.newProject.materials;
      this.company.projects[0].activities = this.newProject.activities;
      this.company.projects[0].mechanizations = this.newProject.mechanizations;
      this.company.projects[0].rentedMechanizations =
        this.newProject.rentedMechanizations;
      this.company.projects[0].manHours = this.newProject.manHours;
      this.company.projects[0].partNotifications =
        this.newProject.partNotifications;
      this.company.projects[0].reporters = this.newProject.reporters;
      this.company.projects[0].isActive = this.newProject.isActive;

      let url = `${process.env.VUE_APP_BASE_URI}/company`;
      this.$http
        .post(url, this.company)
        .then(() => {
          this.$snotify.success("Успешно добавихте нов отдел!");
          this.isCompanyChanged = false;
          this.newLog("newCompany", this.company.companyName);
          this.goBack();
        })
        .catch((error) => {
          console.log(error);
          this.isSaving = false;
          this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
        });
    },
    // UPDATE COMPANY REQUEST
    updateCompany() {
      // NEW PROJECT
      if (this.selectedProject === undefined) {
        this.newProject.projectName = this.searchProjects;
        if (!this.company.projects.includes(this.newProject)) {
          this.company.projects.push(this.newProject);
        }
      }

      // MAKE THE REQUEST
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.company._id}`;
      this.$http
        .put(url, this.company)
        .then(() => {
          this.$snotify.success("Промените са записани успешно!");
          this.isCompanyChanged = false;
          this.newLog("editCompany", this.company.companyName);
          this.goBack();
        })
        .catch((error) => {
          console.log(error);
          this.isSaving = false;
          this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
        });
    },
    deleteCompany() {
      if (this.company._id) {
        if (confirm("Сигурни ли сте, че искате да изтриете този отдел?")) {
          this.$router.push("/companies");
          this.deleteCompanyRequest();
        }
      }
    },
    deleteCompanyRequest() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/${this.company._id}`;
      this.$http
        .delete(url)
        .then(this.$snotify.success("Отделът е изтрит успешно."))
        .catch((error) => {
          if (error.response.status == 404) {
            this.$snotify.error("Не е намерен отдел.");
          } else {
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          }
        });
    },
    // CANCEL
    goBack() {
      this.$router.push("/companies");
    },
    fieldsValidation() {
      if (!this.searchCompanies) {
        this.$snotify.error("Моля въдедете име на отдел.");
        return false;
      }
      if (!this.searchProjects) {
        this.$snotify.error("Моля въведете проект.");
        return false;
      }
      if (this.searchCompanies && this.searchProjects) {
        return true;
      }
    },
    setRoutes() {
      if (this.$route.name === "newCompany") {
        console.log("new company");
      } else if (this.$route.name === "newProject") {
        this.getCompany(this.$route.params.companyId);
      } else if (this.$route.name === "getProject") {
        this.getProject(
          this.$route.params.companyId,
          this.$route.params.projectId
        );
      }
    },
    checkForChanges(next) {
      if (this.isCompanyChanged) {
        this.checkForUnsavedData(next);
      } else {
        next();
      }
    },
  },
  mounted() {
    this.setRoutes();
    this.getCompanies();
    // SAVE HANDLERS
    this.$on("saveAddUsersModal", this.handleReporters);
    this.$on("saveAddMaterialsModal", this.handleMaterials);
    this.$on("saveAddActivitiesModal", this.handleActivities);
    this.$on("saveAddMechanizationsModal", this.handleMechanizations);
    this.$on(
      "saveAddRentedMechanizationsModal",
      this.handleRentedMechanizations
    );
    this.$on("saveEditInputModal", this.handleEdit);
    // CLOSE HANDLERS
    this.$on("closeAddUsersModal", this.closeAddUsersModal);
    this.$on("closeAddMaterialsModal", this.closeAddMaterialsModal);
    this.$on("closeAddActivitiesModal", this.closeAddActivitiesModal);
    this.$on("closeAddMechanizationsModal", this.closeAddMechanizationsModal);
    this.$on(
      "closeAddRentedMechanizationsModal",
      this.closeAddRentedMechanizationsModal
    );
    this.$on("closeEditInputModal", this.closeEditInputModal);
  },
  beforeRouteLeave(to, from, next) {
    if (this.isCompanyChanged) {
      this.checkForUnsavedData(next);
    } else {
      next();
    }
  },
  destroyed() {
    // STOP LISTENING FOR THE EVENTS
    this.$off("saveAddUsersModal");
    this.$off("saveAddMaterialsModal");
    this.$off("saveAddActivitiesModal");
    this.$off("saveAddMechanizationsModal");
    this.$off("saveAddRentedMechanizationsModal");
    this.$off("saveEditInputModal");
    this.$off("closeAddUsersModal");
    this.$off("closeAddMaterialsModal");
    this.$off("closeAddActivitiesModal");
    this.$off("closeAddMechanizationsModal");
    this.$off("closeAddRentedMechanizationsModal");
    this.$off("closeEditInputModal");
  },
};
</script>

<style scoped>
.title {
  color: #373737;
  font-size: 20px;
}
.new-input-wrapper {
  width: 50%;
}
.new-input {
  margin: 0;
}
.new-input--hover input {
  cursor: pointer;
}
.new-input--hover:hover {
  opacity: 0.8;
}
.new-input input {
  padding-right: 50px;
}
.new-input input:disabled {
  text-overflow: ellipsis;
}
.icon--company {
  color: #d67e00;
}
.icon--project {
  color: #a1260d;
}
.icon--reporter {
  color: #652d90;
}
.new-input-dropdown {
  top: calc(100% + 10px);
}
.new-content {
  width: 100%;
}
.new-content-side-panel {
  width: 100%;
  padding: 10px;
  /* height: 100vh; */
  /* overflow: auto; */
}
.new-content-data-row-active {
  border-top: 0;
  flex-direction: row;
  padding-top: 0;
}
.new-content-data-item {
  min-width: calc(100% / 7 - 15px);
  margin-bottom: 0;
}
.new-content-data-item-toggle {
  background-color: #deecf9;
  color: #005a9e;
  line-height: 1rem;
}
.new-content-data-item-toggle:hover {
  background-color: #005a9e;
}
.new-content-data-item-toggle .mck,
.new-content-data-item-toggle .mck2 {
  font-size: 16px;
}
.new-content-data-item-content {
  overflow: auto;
}
/* .new-content-data-item-content table tr td:last-child {
  padding: 0;
  width: 1%;
} */
.new-content-data-item--hoverable {
  cursor: pointer;
  transition: all 0.3s;
}
.new-content-data-item--hoverable:hover {
  background-color: #deecf9;
}
.new-content-data-item--hoverable:hover .new-content-data-item-toggle {
  background-color: #005a9e;
  color: #fff;
}
.new-project-container {
  align-items: center;
  margin-left: 40px;
  margin-right: 20px;
  margin-bottom: 27px;
}
.new-project-container-side-panel {
  margin-left: 24px;
  width: 75%;
}
.new-project-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-top: 11px;
}
.new-project-header .left {
  align-items: center;
  display: flex;
}
.left-project-name {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  height: 30px;
  line-height: 11px;
  margin-right: 10px;
  overflow: hidden;
  padding: 0 10px;
  text-overflow: ellipsis;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.project-settings {
  align-items: center;
  color: #005a9e;
  cursor: pointer;
  display: inline-flex;
  font-size: 12px;
  gap: 4px;
}
.project-settings:hover {
  opacity: 0.8;
}
.project-settings .mck2 {
  font-size: 16px;
}
.project-settings p {
  font-weight: 700;
  text-decoration: underline;
}

.new-project-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  width: 100%;
}
.buttons-wrapper {
  display: flex;
  flex-direction: row;
}
.switch-wrapper {
  align-items: center;
  background-color: rgba(177, 177, 177, 0.2);
  border-radius: 4px;
  display: flex;
  margin-left: 10px;
  padding-right: 10px;
}
.switch {
  margin: 0 8px;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
  white-space: nowrap;
}
.switch-label-active {
  opacity: 1;
}
.delete-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  width: 100%;
}
.new-img {
  cursor: pointer;
  transition: all 0.3s;
  width: 100%;
  mix-blend-mode: luminosity;
}
.new-img:hover {
  mix-blend-mode: multiply;
}
.new-content-data-item-content .ma-cell-left,
.new-content-data-item-toggle .ma-cell-left {
  padding-left: 0;
}
.nowrap {
  white-space: nowrap;
}
/* .desktop {
  display: flex;
} */
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .projects-wrapper {
    justify-content: center;
  }
  .new-project-container-side-panel {
    width: 100%;
  }
  .new-project-container {
    width: 92%;
    margin: 0 15px;
    margin-bottom: 27px;
  }
  .new-content-inputs {
    display: flex;
    flex-direction: column;
  }
  .new-input-wrapper {
    margin-right: 0px;
    width: 100%;
  }
  .new-project-header {
    justify-content: center;
  }
  .new-content-data-row-active {
    flex-direction: column;
  }
  .new-content-data-item-toggle.mobile {
    text-align: center;
    flex-direction: column;
    height: 100%;
    padding-bottom: 0.6em;
  }
  .new-content-data-item-toggle.mobile p {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }
  .btns.mobile {
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }
  .delete-wrapper {
    justify-content: center;
  }
  .btn.btn-delete {
    width: 330px;
  }
  .new-content {
    width: 100%;
  }
  .new-content-data-item-content-lists > span {
    width: 30%;
  }
  .new-content-data-item-content-lists {
    overflow: auto;
  }
  .new-content-data-item-content .ma-cell {
    padding: 0px;
  }
}
@media screen and (max-width: 340px) {
  .new-content-data-item {
    margin-right: 4px;
  }
}
</style>
